import { load } from './util';

$(document).on('submit', '[data-registration-pw-reset]', function(event) {
  event.preventDefault();

  const promise = $.ajax({
    url: $(this).attr('action'),
    method: 'POST',
    data: $(this).serializeArray(),
  });

  const $reveal = $(this).closest('[data-reveal]');
  load($reveal, promise).then((result) => {
    setTimeout(() => $reveal.foundation('close'), 1500);
    return result;
  });
});

$(document).on('submit', '[data-registration-box] form', function() {
  $(this).closest('[data-registration-box]').addClass('loading');
});

$(document).on('change', '[data-registration-type-select]', (event) => {
  const type = event.target.value;
  $('[data-registration-form]').hide();
  $(`[data-registration-form="${type}"]`).show();
});
